import { render, staticRenderFns } from "./LaudoAvaliacaoAreaProdutivaModal.vue?vue&type=template&id=311fbce4&scoped=true&lang=pug"
import script from "./LaudoAvaliacaoAreaProdutivaModal.vue?vue&type=script&lang=js"
export * from "./LaudoAvaliacaoAreaProdutivaModal.vue?vue&type=script&lang=js"
import style0 from "./LaudoAvaliacaoAreaProdutivaModal.vue?vue&type=style&index=0&id=311fbce4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311fbce4",
  null
  
)

export default component.exports